module.exports = function getResource(label, vars = []) {
    const resources = {
        unsubscribeModalConfirmTitle: 'Unsubscribed',
        unsubscribeModalConfirmMsg: 'You have sucessfully unsubscribed from your Auto-Replenish item.',
        unsubscribeModalConfirmButtonText: 'Done',
        errorMessage: 'Oops! Something went wrong and we were unable to process your changes. Please try again later.',
        manageSubscription: 'Manage Subscription',
        unsubscribeItem: 'Unsubscribe Item',
        updateSubscriptionError: 'Update Subscription',
        pausedSubscriptionModalConfirmTitle: 'Paused Item',
        pausedSubscriptionModalConfirmMsg: 'Your Auto-Replenish item has been paused. You may select resume at any time to resume delivery.',
        pausedSubscriptionModalConfirmButtonText: 'Done',
        skipItemUnavailable: 'Skip Item Unavailable',
        skipedSubscriptionModalConfirmTitle: 'Skipped Item',
        nextShipmentText: 'Your Auto-Replenish item will skip its next shipment and resume on',
        pause: 'Pause',
        resumeItem: 'Resume Item',
        deleteCard: 'Delete Card',
        addNewCard: 'Add New Credit or Debit Card',
        editCard: 'Edit Credit Card or Debit Card',
        pauseItem: 'Pause Item',
        addressRemovalModalTitle: 'Remove Address',
        addressRemovalModalBody: 'Are you sure you want to remove this address?',
        addressRemovalModalConfirmButtonText: 'Remove Address',
        addressRemovalModalFailureButtonText: 'OK',
        addressRemovalModalBodyFailure: 'Unable to remove address. This address is used as\n' +
            'your address for a subscription. To remove, change the subscription(s) to a different address.',
        limitReachedTitle: 'Maximum Reached',
        limitReachedBody: 'Please delete one of your saved addresses before adding a new one.',
        limitReachedConfirmButtonText: 'OK',
        orderConfirmationTitle: 'Order Confirmation',
        orderConfirmationBody: `Thank you! Your order number is #${vars[0]}. You’ll receive a confirmation email at <b>${vars[1]}</b>`,
        orderConfirmationConfirmButtonText: 'Got It',
        orderConfirmationErrorTitle: 'Order Placement Error',
        orderNowTooSoonTitle: 'Too Soon to Reorder',
        orderNowTooSoonBody: `You've already placed a Get It Now order in the last ${vars[0]} days. Please come in ${vars[1]} days to order again.`
    };
    return resources[label];
};
